export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-dk.199e3023.png";